export type PeriodValidation =
  | { ok: true }
  | { ok: false; reason: 'too_long' | 'reversed'; message: string };

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function validatePeriod(
  dateFrom: string,
  dateTo: string,
  maxDays = 366,
): PeriodValidation {
  const from = new Date(dateFrom).getTime();
  const to = new Date(dateTo).getTime();
  if (from > to) {
    return { ok: false, reason: 'reversed', message: 'Дата «с» позже даты «по»' };
  }
  const days = Math.round((to - from) / MS_PER_DAY);
  if (days > maxDays) {
    return {
      ok: false,
      reason: 'too_long',
      message: `Период не может превышать ${maxDays} дней`,
    };
  }
  return { ok: true };
}
